(() => {
  const norm = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const updateGallery = () => {
    const selected = document.querySelector('input[data-option-name="Color"]:checked');
    if (!selected) return;
    const color = norm(selected.value);
    const colors = [...document.querySelectorAll('input[data-option-name="Color"]')].map((input) => norm(input.value)).filter(Boolean);
    document.querySelectorAll('media-gallery .product-media[data-media-id]').forEach((item) => {
      const alt = norm(item.querySelector('img')?.alt);
      if (!alt || !colors.some((value) => alt.includes(value))) return;
      const card = item.closest('slideshow-slide, li.product-media-container, .product-media-container, .product-gallery__media') || item;
      const show = alt.includes(color) && !(color === 'blanco' && alt.includes('rosa y blanco'));
      card.hidden = !show;
      card.style.display = show ? '' : 'none';
      card.setAttribute('aria-hidden', String(!show));
    });
  };
  const schedule = () => { updateGallery(); setTimeout(updateGallery, 80); setTimeout(updateGallery, 300); };
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  window.addEventListener('popstate', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'alt', 'checked', 'data-current-checked'] });
  schedule();
})();